import { render, staticRenderFns } from "./AddTipModal.vue?vue&type=template&id=244293dc&scoped=true&"
import script from "./AddTipModal.vue?vue&type=script&lang=js&"
export * from "./AddTipModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTipModal.vue?vue&type=style&index=0&id=244293dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244293dc",
  null
  
)

export default component.exports